// extracted by mini-css-extract-plugin
export default {"container":"UserDetails_container__chw+G","username":"UserDetails_username__PJfGD","roleName":"UserDetails_roleName__u0Wc7","divider":"UserDetails_divider__U7Bhz"};